import { DB, ExecuteResult, SQLBatchTuple } from './index';
import time from '../time';
import { User } from './t_user';

export interface GroupMember {
    tid: string;
    uid: number;
    name: string,
    namePY: string,
    namePYS: string,
    nick: string,
    nickPY: string,
    nickPYS: string,
    sex: string,
    birth: string,
    privacy: string
    telno: string,
    email: string,
    appkey: string,
    mainAppkey: string,
    avatar: string,
    status: string,
    remark: string,
    lutime: number;
    lctime: number;
}

export const defaultUser: GroupMember = {
    tid: '',
    uid: 0, // uid
    name: '', // 名称
    sex: '', //
    birth: '', //
    privacy: '', //
    namePY: '', // 名称 拼音
    namePYS: '', // 名称 拼音首字母
    nick: '', // 昵称
    nickPY: '', // 昵称 拼音
    nickPYS: '', // 昵称 拼音首字母
    telno: '', // 手机号 登陆时作为账号
    email: '', // 邮箱 登陆时作为账号
    appkey: '', // 应用 关联到具体某个公司
    mainAppkey: '', // 主应用 多个公司
    avatar: '', // 头像
    remark: '', // 不是表字段 备注
    status: '',
    lutime: 0,
    lctime: 0,
};

type Entity = {
    tid: string;
    uid: number;
    name: string,
    name_py: string; // 名称 拼音
    name_pys: string; // 名称 拼音首字母
    nick: string,
    nick_py: string; // 昵称 拼音
    nick_pys: string; // 昵称 拼音首字母
    sex: string,
    birth: string,
    privacy: string
    telno: string,
    email: string,
    appkey: string,
    main_appkey: string,
    avatar: string,
    remark: string,
    status: string,
    lutime: number;
    lctime: number;
};

function GroupMemberToEntity(a: GroupMember): Entity {
    const b: Entity = {
        tid: a.tid,
        uid: a.uid, // uid
        name: a.name, // 名称
        sex: a.sex, //
        birth: a.birth, //
        privacy: a.privacy, //
        name_py: a.namePY, // 名称 拼音
        name_pys: a.namePYS, // 名称 拼音首字母
        nick: a.nick, // 昵称
        nick_py: a.nickPY, // 昵称 拼音
        nick_pys: a.nickPYS, // 昵称 拼音首字母
        telno: a.telno, // 手机号 登陆时作为账号
        email: a.email, // 邮箱 登陆时作为账号
        appkey: a.appkey, // 应用 关联到具体某个公司
        main_appkey: a.mainAppkey, // 主应用 多个公司
        avatar: a.avatar, // 头像
        remark: a.remark, // 不是表字段 备注
        status: a.status,
        lutime: a.lutime,
        lctime: a.lctime,
    };
    return b;
}

function fixUser(a: GroupMember): GroupMember {
    return Object.assign({}, defaultUser, a);
}


const upsert_sql =
    'insert into t_group_member(' +
    ' primaryId, tid, uid, name, name_py, name_pys, ' +
    ' nick, nick_py, nick_pys, sex, birth,' +
    ' privacy, telno, email, appkey, main_appkey,' +
    ' avatar,remark, status, lutime, lctime' +
    ') values (' +
    ' ?, ?, ?, ?, ?,' +
    ' ?, ?, ?, ?, ?,' +
    ' ?, ?, ?, ?, ?,' +
    ' ?, ?, ?, ?, ?, ?' +
    ') ON CONFLICT(primaryId) DO UPDATE SET' +
    ' name=?, name_py=?, name_pys=?, nick=?, nick_py=?, nick_pys=?,sex=?, birth=?,' +
    ' privacy=?, telno=?, email=?,' +
    ' appkey=?, main_appkey=?, avatar=?, remark=?,status=?, lutime=? ;';

export async function group_member_upsert(
    db: DB,
    users: GroupMember[]
) {
    const commands: SQLBatchTuple[] = [];
    const n = users.length;
    for (let i = 0; i < n; i++) {
        const t = time.toUnixMillSecond(time.now());
        const d = GroupMemberToEntity(fixUser(users[i]));
        d.lutime = t;
        d.lctime = t;
        const params = [];
        // const sql =
        //     'insert into t_group_member(tid, uid, flag, groupNick,lutime, lctime) values(?,?,?,?,?,?)' +
        //     ' ON CONFLICT(tid,uid,flag)' +
        //     ' DO UPDATE SET groupNick=?, lutime=?';
        // ' tid, uid, name, name_py, name_pys, ' +
        // ' nick, nick_py, nick_pys, sex, birth,' +
        // ' privacy, telno, email, appkey, main_appkey,' +
        // ' avatar,remark, lutime, lctime' +
        const primaryId = `${d.tid}_${d.uid}`
        // INSERT
        params.push(...[primaryId, d.tid, d.uid, d.name, d.name_py, d.name_pys, d.nick, d.nick_py, d.nick_pys]);
        params.push(...[d.sex, d.birth, d.privacy, d.telno, d.email, d.appkey, d.main_appkey]);
        params.push(...[d.avatar, d.remark, d.status, d.lutime, d.lctime]);
        // UPDATE
        //   ' name=?, name_py=?, name_pys=?, nick=?, nick_py=?, nick_pys=?,sex=?, birth=?,' +
        //     ' privacy=?,  telno=?, email=?' +
        //     ' appkey=?, main_appkey=?, avatar=?,  remark=?, lutime=? ;';
        params.push(...[d.name, d.name_py, d.name_pys, d.nick, d.nick_py, d.nick_pys, d.sex, d.birth]);
        params.push(...[d.privacy, d.telno, d.email]);
        params.push(...[d.appkey, d.main_appkey],);
        params.push(...[d.avatar, d.remark, d.status, d.lutime]);

        commands.push([upsert_sql, params]);
    }
    return await db.BatchExecute(commands);
}



export async function group_member_update_mine(db: DB, user: User) {
    const updates: string[] = [];
    const params: any[] = [];

    // 动态构建更新字段
    if (user.name != null) {
        updates.push(`name = ?`);
        params.push(user.name);
    }
    if (user.namePY != null) {
        updates.push(`name_py = ?`);
        params.push(user.namePY);
    }
    if (user.namePYS != null) {
        updates.push(`name_pys = ?`);
        params.push(user.namePYS);
    }
    if (user.nick != null) {
        updates.push(`nick = ?`);
        params.push(user.nick);
    }
    if (user.nickPY != null) {
        updates.push(`nick_py = ?`);
        params.push(user.nickPY);
    }
    if (user.nickPYS != null) {
        updates.push(`nick_pys = ?`);
        params.push(user.nickPYS);
    }
    if (user.sex != null) {
        updates.push(`sex = ?`);
        params.push(user.sex);
    }
    if (user.avatar != null) {
        updates.push(`avatar = ?`);
        params.push(user.avatar);
    }
    if (user.birth != null) {
        updates.push(`birth = ?`);
        params.push(user.birth);
    }
    if (user.remark != null) {
        updates.push(`remark = ?`);
        params.push(user.remark);
    }
    if (user.telno != null) {
        updates.push(`telno = ?`);
        params.push(user.telno);
    }
    if (user.email != null) {
        updates.push(`email = ?`);
        params.push(user.email);
    }
    if (user.status != null) {
        updates.push(`status = ?`);
        params.push(user.status);
    }

    if (updates.length === 0) return; // 没有更新字段

    const sql = `
    UPDATE t_group_member
    SET ${updates.join(', ')}
    WHERE uid = ?
  `;
    params.push(user.uid);

    await db.Execute(sql, params);
}


export async function group_member_update_mine_remark(
    db: DB,
    uid: number,
    remark: string
) {
    let sql = `UPDATE t_group_member SET remark = ? WHERE  uid = ?`
    const r = await db.Execute(sql, [remark, uid]);
}


export async function group_member_remove_notin(
    db: DB,
    tid: string,
    uids: number[],
): Promise<ExecuteResult> {
    if (!uids || !(uids.length > 0)) {
        return { error: -1, insertId: 0, rowsAffected: 0 }
    }
    if (!uids || uids.length === 0) {
        // 如果没有保留的 uid，就直接删除所有 tid 下的成员
        const sqlstr = `DELETE FROM t_group_member WHERE tid = ?`;
        return await db.Execute(sqlstr, [tid]);
    }

    const placeholders = uids.map(() => '?').join(', ');
    const sqlstr = `
    DELETE FROM t_group_member
    WHERE tid = ?
      AND uid NOT IN (${placeholders})
  `;
    const params = [tid, ...uids];
    // let sqlstr = `delete from t_group_member where tid='${tid}'` + 'and uid not in (' + a + ')';
    return await db.Execute(sqlstr, params);
}

/** 在 tid 下哪些 uid 尚不在 t_group_member（用于增量同步前过滤 /topic/user/detail） */
export async function group_member_missing_uids(
    db: DB,
    tid: string,
    uids: number[],
): Promise<{ error: any; missing: number[] }> {
    const uniq = [...new Set((uids || []).filter((u) => u > 0 && Number.isFinite(u)))];
    if (!uniq.length) {
        return { error: null, missing: [] };
    }
    const placeholders = uniq.map(() => '?').join(', ');
    const sql = `select uid from t_group_member where tid = ? and uid in (${placeholders})`;
    const r = await db.Query(sql, [tid, ...uniq]);
    if (r.error) {
        return { error: r.error, missing: uniq };
    }
    const have = new Set<number>();
    if (r.data && r.data.length > 0) {
        for (const row of r.data as { uid?: number }[]) {
            if (row.uid != null) {
                have.add(Number(row.uid));
            }
        }
    }
    const missing = uniq.filter((u) => !have.has(u));
    return { error: null, missing };
}

export async function group_member_qry(
    db: DB,
    tid: string,
): Promise<{ error: any; data?: GroupMember[] }> {
    const sql = `select * from t_group_member where tid=?`;
    const r = await db.Query(sql, [tid]);
    if (r.error) {
        return { error: r.error };
    }
    if (!(r.data && r.data.length > 0)) {
        return { error: null };
    }
    const d = r.data as GroupMember[];
    return { error: null, data: d };
}

// 根据用户 找涉及的群会话
export async function group_member_qry_topic(
    db: DB,
    uid: number,
): Promise<{ error: any; tids?: string[] }> {
    const sql = `select tid from t_group_member where uid= ?`;
    const r = await db.Query(sql, [uid]);
    if (r.error) {
        return { error: r.error };
    }
    if (!r.data) {
        return { error: null };
    }

    const d = r.data as { tid: string }[];
    return {
        error: null,
        tids: d.map((v) => {
            return v.tid;
        }),
    };
}
